var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.76087 5L9.81884 0.923913C10.0362 0.706522 10.0362 0.362319 9.81884 0.163043C9.60145 -0.0543478 9.25725 -0.0543478 9.05797 0.163043L5 4.23913L0.923913 0.163043C0.706522 -0.0543478 0.362319 -0.0543478 0.163043 0.163043C-0.0543478 0.380435 -0.0543478 0.724638 0.163043 0.923913L4.22101 5L0.163043 9.07609C-0.0543478 9.29348 -0.0543478 9.63768 0.163043 9.83696C0.271739 9.94565 0.416667 10 0.543478 10C0.67029 10 0.815217 9.94565 0.923913 9.83696L5 5.76087L9.07609 9.83696C9.18478 9.94565 9.32971 10 9.45652 10C9.58333 10 9.72826 9.94565 9.83696 9.83696C10.0543 9.61957 10.0543 9.27536 9.83696 9.07609L5.76087 5Z",
    fill: "#010101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.43f758c5caaa95b9a17fedd754d59a46.svg";
export { ForwardRef as ReactComponent };